import * as types from 'modules/devices/actionTypes';
import type { Device } from 'modules/devices/types';
import type { Action } from 'modules/global/generic.types';
import { createReducer } from 'utils/ReduxUtils';

type CreatedDevice = (Device & { env?: string }) | null;

const initialState: CreatedDevice = null;

const afterCreateDevice = (_: CreatedDevice, { payload }: Action<Device & { env?: string }>) => payload ?? null;

const cleanCreatedDevice = () => null;

export default createReducer<CreatedDevice>(initialState, {
  [types.CREATE_DEVICE_SUCCESS]: afterCreateDevice,
  [types.CLEAN_CREATED_DEVICE]: cleanCreatedDevice,
});
